import React from 'react';
import "./Material.css";
import { useTranslation } from 'react-i18next';

function Material() {

  const { t } = useTranslation();

  return (
    <div className='material-container'>
      <div className="material-content">

        <div className='material-header'>
          <h3>{t('nav_technologies_material')}</h3>
        </div>
        <div className='pro-text-promotion'>

          <p>{t('techno-material-p-text-one')}</p>
          <p>{t('techno-material-p-text-two')}</p>
          <p>{t('techno-material-p-text-three')}</p>

        </div>



        <div className='material-tablo-container'>
          <table>
            <thead>
              <tr>
                <th>{t('techno-material-table-header-one')}</th>
                <th>{t('techno-material-table-header-two')}</th>
                <th>{t('techno-material-table-header-three')}</th>
                <th>{t('techno-material-table-header-four')}</th>
                <th>{t('techno-material-table-header-five')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className='td-one'>{t('material-table-desk-one-td-one')}</td>
                <td className='nr'>{t('material-table-desk-one-td-two')}</td>
                <td>
                  {t('material-table-desk-one-td-three')}
                  <br />
                  {t('material-table-desk-one-td-three2')}
                </td>
                <td className='degre'>{t('material-table-desk-one-td-four')}</td>
                <td>{t('material-table-desk-one-td-five')}</td>
              </tr>
              <tr className='tr-light'>
                <td className='td-one'>{t('material-table-desk-two-td-one')}</td>
                <td className='nr'>{t('material-table-desk-two-td-two')}</td>
                <td>
                  {t('material-table-desk-two-td-three')}
                  <br />
                  {t('material-table-desk-two-td-three2')}
                </td>
                <td className='degre'>{t('material-table-desk-two-td-four')}</td>
                <td>{t('material-table-desk-two-td-five')}</td>
              </tr>
              <tr>
                <td className='td-one'>{t('material-table-desk-three-td-one')}</td>
                <td className='nr'>{t('material-table-desk-three-td-two')}</td>
                <td>
                  {t('material-table-desk-three-td-three')}
                  <br />
                  {t('material-table-desk-three-td-three2')}
                </td>
                <td className='degre'>{t('material-table-desk-three-td-four')}</td>
                <td>{t('material-table-desk-three-td-five')}</td>
              </tr>
              <tr className='tr-light'>
                <td className='td-one'>{t('material-table-desk-four-td-one')}</td>
                <td className='nr'>{t('material-table-desk-four-td-two')}</td>
                <td>
                  {t('material-table-desk-four-td-three')}
                  <br />
                  {t('material-table-desk-four-td-three2')}
                  <br />
                  {t('material-table-desk-four-td-three3')}
                </td>
                <td className='degre'>{t('material-table-desk-four-td-four')}</td>
                <td>{t('material-table-desk-four-td-five')}</td>
              </tr>
              <tr>
                <td className='td-one'>{t('material-table-desk-five-td-one')}</td>
                <td className='nr'>{t('material-table-desk-five-td-two')}</td>
                <td>{t('material-table-desk-five-td-three')}</td>
                <td className='degre'>{t('material-table-desk-five-td-four')}</td>
                <td>{t('material-table-desk-five-td-five')}</td>
              </tr>
              <tr className='tr-light'>
                <td className='td-one'>{t('material-table-desk-six-td-one')}</td>
                <td className='nr'>{t('material-table-desk-six-td-two')}</td>
                <td>
                  {t('material-table-desk-six-td-three')}
                  <br />
                  {t('material-table-desk-six-td-three2')}
                  <br />
                  {t('material-table-desk-six-td-three3')}
                </td>
                <td className='degre'>{t('material-table-desk-six-td-four')}</td>
                <td>{t('material-table-desk-six-td-five')}</td>
              </tr>

              <tr>
                <td className='td-one'>{t('material-table-desk-seven-td-one')}</td>
                <td className='nr'>{t('material-table-desk-seven-td-two')}</td>
                <td>
                  {t('material-table-desk-seven-td-three')}
                  <br />
                  {t('material-table-desk-seven-td-three2')}
                  <br />
                  {t('material-table-desk-seven-td-three3')}
                </td>
                <td className='degre'>{t('material-table-desk-seven-td-four')}</td>
                <td>{t('material-table-desk-seven-td-five')}</td>
              </tr>

              <tr className='tr-light'>
                <td className='td-one'>v{t('material-table-desk-eight-td-one')}</td>
                <td className='nr'>{t('material-table-desk-eight-td-two')}</td>
                <td>
                  {t('material-table-desk-eight-td-three')}
                  <br />
                  {t('material-table-desk-eight-td-three2')}
                </td>
                <td className='degre'>{t('material-table-desk-eight-td-four')}</td>
                <td>{t('material-table-desk-eight-td-five')}</td>
              </tr>
              <tr>
                <td className='td-one'>{t('material-table-desk-nine-td-one')}</td>
                <td className='nr'>{t('material-table-desk-nine-td-two')}</td>
                <td>{t('material-table-desk-nine-td-three')}</td>
                <td className='degre'>{t('material-table-desk-nine-td-four')}</td>
                <td>{t('material-table-desk-nine-td-five')}</td>
              </tr>
              <tr className='tr-light'>
                <td className='td-one'>{t('material-table-desk-ten-td-one')}</td>
                <td className='nr'>{t('material-table-desk-ten-td-two')}</td>
                <td>
                  {t('material-table-desk-ten-td-three')}
                  <br />
                  {t('material-table-desk-ten-td-three2')}
                </td>
                <td className='degre'>{t('material-table-desk-ten-td-four')}</td>
                <td>{t('material-table-desk-ten-td-five')}</td>
              </tr>

              <tr>
                <td className='td-one'>{t('material-table-desk-eleven-td-one')}</td>
                <td className='nr'>{t('material-table-desk-eleven-td-two')}</td>
                <td>
                  {t('material-table-desk-eleven-td-three')}
                  <br />
                  {t('material-table-desk-eleven-td-three2')}
                </td>
                <td className='degre'>{t('material-table-desk-eleven-td-four')}</td>
                <td>{t('material-table-desk-eleven-td-five')}</td>
              </tr>
            </tbody>
          </table>

        </div>


      </div>
    </div>
  )
}

export default Material
